// @ts-expect-error not migrated yet
import AsyncComponentContext from 'ContentEditorUI/context/AsyncComponentContext';
import { jsx as _jsx } from "react/jsx-runtime";
const BlogPreviewRouteContainer = () => {
  return /*#__PURE__*/_jsx(AsyncComponentContext.Consumer, {
    children: ({
      PreviewModalContainer
    }) => /*#__PURE__*/_jsx(PreviewModalContainer, {})
  });
};
export default BlogPreviewRouteContainer;